import { judgeClient } from './browser'

type ServiceCode = 'cloud.storage' | 'monitoring.service'

type INativeInfo = {
  email: string
  token: string
  gtoken: string
  appName: string
  appVersion: string
  domain: string
  country: string
}

/** @deprecated use EVT_PAGE_VISITED instead */
export const EVT_PAGE_ENTER = 10001
export const EVT_PAGE_VISITED = 10001
export const EVT_PAGE_LOADING = 10002
export const EVT_PAGE_STAYING = 10003
export const EVT_CLICK = 10100
export const VERSION_LOG = 100

function getCookie(cname: string) {
  var name = cname + '='
  var decodedCookie = decodeURIComponent(document.cookie)
  var ca = decodedCookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

type WindowWithBridge = {
  WebViewJavascriptBridge?: any
  WVJBCallbacks?: any
  EufyJS?: any
  HomeBack?: any
  AndroidBack?: any
} & Window

export function setupWebViewJavascriptBridge(callback) {
  const top = window.top as WindowWithBridge
  if (top.WebViewJavascriptBridge) {
    return callback(top.WebViewJavascriptBridge)
  }
  if (top.WVJBCallbacks) {
    return top.WVJBCallbacks.push(callback)
  }
  top.WVJBCallbacks = [callback]
  const WVJBIframe = document.createElement('iframe')
  WVJBIframe.style.display = 'none'
  WVJBIframe.src = 'wvjbscheme://__bridge_loaded__'
  document.documentElement.appendChild(WVJBIframe)
  setTimeout(() => {
    document.documentElement.removeChild(WVJBIframe)
  }, 0)
}

function callByIOS(params) {
  const innerParams = Object.assign({}, params, { key_event: true })

  setupWebViewJavascriptBridge(bridge => {
    bridge.callHandler('logEventWithParam', innerParams, response => {
      console.log(response)
    })
  })
}

function callByAndroid(params) {
  ;(window as WindowWithBridge).EufyJS?.collectData(JSON.stringify(params))
}

type NativeAppParams = {
  androidBack?: () => void
  homeBack?: () => void
}

export function nativeApp({ androidBack, homeBack }: NativeAppParams) {
  ;(window as WindowWithBridge).AndroidBack = () => {
    androidBack?.()
  }
  ;(window as WindowWithBridge).HomeBack = () => {
    homeBack?.()
  }
}

export function navBarStatusChange(params) {
  if (judgeClient() === 'iOS') {
    setupWebViewJavascriptBridge(bridge => {
      bridge.callHandler('navBarStatusChange', params, response => {
        console.log(response)
      })
    })
    return
  }
  if (judgeClient() === 'Android') {
    const win = window as WindowWithBridge
    const paramStr = JSON.stringify(params)

    win.EufyJS?.navBarStatusChange?.(paramStr)
  }
}

export function getNativeInfo(): Promise<INativeInfo> {
  return new Promise((resolve, reject) => {
    if (judgeClient() === 'iOS') {
      return setupWebViewJavascriptBridge(bridge => {
        bridge.callHandler('getNativeInfo', {}, response => {
          resolve(response)
        })
      })
    }
    if (judgeClient() === 'Android') {
      const win = window as WindowWithBridge
      return Promise.resolve(win.EufyJS?.getNativeInfo()).then(resp =>
        JSON.parse(resp)
      )
    }
    reject('Not Supported')
  })
}

export function collectData(params) {
  if (params) {
    let abTest =
      localStorage.abTestMode === undefined
        ? VERSION_LOG
        : VERSION_LOG + Number(localStorage.abTestMode)
    params.log_version = abTest
  }

  params.business = params.business || 'Mall'

  if (judgeClient() === 'iOS') {
    callByIOS(params)
  } else if (judgeClient() === 'Android') {
    callByAndroid(params)
  }
}

/**
 * 跳转到服务页面
 * @param serviceCode - cloud.storage: 云服务, monitoring.service: 报警服务
 * @param classId - 不同计划, 不传则直接到套餐选择页面
 */
export const jumpToPlan = (
  serviceCode: ServiceCode,
  classId: string | number | null,
  entrance: string
): string | void => {
  const appVersion = getCookie('app_version').match(/v(\d+\.\d+\.\d+)/)?.[1]
  const osType = getCookie('os_type')
  if (
    // Android 在 2.7.0 中支持
    osType === 'android' &&
    appVersion < '2.7.0'
  ) {
    return 'Please upgrade to V2.7.0 of the app to access.'
  }
  // iOS 在
  if (appVersion < '2.8.0') {
    return 'Please upgrade to V2.8.0 of the app to access.'
  }
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.src = `eufysecurity://eufy/vas/plan?serviceCode=${serviceCode}&classId=${
    classId || ''
  }&entrance=${entrance}`
  document.body.appendChild(iframe)
  setTimeout(() => {
    document.body.removeChild(iframe)
  }, 5000)
}

export const showAlert = (htmlStr: string) => {
  const appVersion = getCookie('app_version')
  const osType = getCookie('os_type')
  if (
    (osType === 'android' &&
      appVersion < (appVersion.indexOf('QA') > -1 ? 'QA_v2.8.0' : 'v2.8.0')) ||
    appVersion < '2.8.0'
  ) {
    alert('Please upgrade to V2.8.0 of the app to access.')
    return
  }
  setupWebViewJavascriptBridge(bridge => {
    bridge.callHandler(
      'alarmDialogEventWithParam',
      `<html><body>${htmlStr}</body></html>`,
      response => {
        console.log(response)
      }
    )
  })
}

/**
 * 由于安卓需要兼容AB test所以单独传参数判断
 *
 */
export function getAlramServiceWaysToBuy() {
  return new Promise((resolve, reject) => {
    if (judgeClient() === 'Android') {
      const win = window as WindowWithBridge
      return resolve(win.EufyJS?.getAlramServiceWaysToBuy())
    }
    reject('Not Supported')
  })
}

// 由于为了兼容报警服务页面所以暂时多加一个方法，后续删除
export function getNativeInfoUser() {
  return new Promise((resolve, reject) => {
    if (judgeClient() === 'iOS') {
      setupWebViewJavascriptBridge(bridge => {
        bridge.callHandler('getNativeInfo', {}, response => {
          resolve(response)
        })
      })
      return
    }
    if (judgeClient() === 'Android') {
      const win = window as WindowWithBridge
      const paramStr = JSON.stringify({})
      return resolve(win.EufyJS?.getNativeInfo())
    }
    reject('Not Supported')
  })
}
